import { ALL_MONDAY_SCHEMAS, type MONDAY_TYPES } from "@onesolution/monday";
import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const itemsQuery = <T>(
	params: {
		itemIds: string[];
		columnIds: string[];
		extraQuery?: string;
	} & Record<string, unknown>,
) =>
	requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
                query GetItems(
                    $itemIds: [ID!]!,
                    $columnIds: [String!]! ,
                ) {
                    items(ids: $itemIds, limit: 100) {
                        id
                        name
                        ${params.extraQuery || ""}
                        column_values(ids: $columnIds) {
                            ${ALL_MONDAY_SCHEMAS}
                            
                            ... on BoardRelationValue {
                                linked_item_ids
                                display_value
                            }
                        }
                    }
                }
                `,
			resultKey: "items",
			autobatch: { key: "itemIds" },
			outType: [] as Array<MONDAY_TYPES["base"] & T>,
		},
		params,
	);
